const course = [
  {
    image:
      "https://instructory-aws-storage.s3.us-west-1.amazonaws.com/course_thumbnails/61745bfea588c.jpg",
    instructor: "SALIFOU SAYE Mouhamadou",
    title: "Full Stact Web Development in MERN Stack",
    price: 300,
    rating: 10,
  },
  {
    image:
      "https://instructory-aws-storage.s3.us-west-1.amazonaws.com/course_thumbnails/61745bfea588c.jpg",
    instructor: "SALIFOU SAYE Mouhamadou",
    title: "Full Stact Web Development in MERN Stack",
    price: 300,
    rating: 10,
  },
  {
    image:
      "https://instructory-aws-storage.s3.us-west-1.amazonaws.com/course_thumbnails/61745bfea588c.jpg",
    instructor: "SALIFOU SAYE Mouhamadou",
    title: "Full Stact Web Development in MERN Stack",
    price: 300,
    rating: 10,
  },
  {
    image:
      "https://instructory-aws-storage.s3.us-west-1.amazonaws.com/course_thumbnails/61745bfea588c.jpg",
    instructor: "SALIFOU SAYE Mouhamadou",
    title: "Full Stact Web Development in MERN Stack",
    price: 300,
    rating: 10,
  },
];

export default course;
